import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const DropdownMenuItemLi = styled.li<{ $mobileOnly?: boolean }>`
  list-style: none;
  margin: 0;
  padding: 0;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    ${({ $mobileOnly }) => ($mobileOnly ? 'display: none;' : undefined)}
  }
`;
